import * as React from 'react'

import { ButtonLarge } from '~ui/components/buttons/ButtonSizes/ButtonLarge'

import { useFormSubmitCtx } from '../contexts/FormProvider'
import { useFormSubmitButtonLabel } from '../hooks/useFormSubmitButtonLabel'

type TProps = NoChildren

/**
 * A button for submitting the order form.
 */
export const FormSubmitButtonDesktop: React.FC<TProps> = () => {
  const submitForm = useFormSubmitCtx()
  const submitLabel = useFormSubmitButtonLabel({ isMobile: false })

  return (
    <ButtonLarge onClick={submitForm} bgColor={`conversion`}>
      {submitLabel}
    </ButtonLarge>
  )
}
